/**
 * @generated SignedSource<<88aac81a8d91ec19fddd50e7e80f015c>>
 * @relayHash 75a8ab967a8a47268b97e941c97fbda1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a3c9324a87e6361ec47846a5c5dbe84fb7e664f6d7174fca7a5292d238987707

import type { ConcreteRequest, Query } from 'relay-runtime';
export type portalDropdownPortalsQuery$variables = {
  cloudId: string;
  hubAri: string;
};
export type portalDropdownPortalsQuery$data = {
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly __typename: "HelpCenter";
      readonly portals: {
        readonly portalsList: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null | undefined;
        }> | null | undefined;
      } | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type portalDropdownPortalsQuery = {
  response: portalDropdownPortalsQuery$data;
  variables: portalDropdownPortalsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "hubAri"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "HelpCenterPortals",
      "kind": "LinkedField",
      "name": "portals",
      "plural": false,
      "selections": [
        {
          "concreteType": "HelpCenterPortal",
          "kind": "LinkedField",
          "name": "portalsList",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            {
              "kind": "ScalarField",
              "name": "name"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "portalDropdownPortalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "portalDropdownPortalsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a3c9324a87e6361ec47846a5c5dbe84fb7e664f6d7174fca7a5292d238987707",
    "metadata": {},
    "name": "portalDropdownPortalsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6e5932f98ce83851f345ba3cbfb855c0";

export default node;
